import React from 'react'

import Icon from '@/components/common/Icon'

const IconDelivery: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_384_3647"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="48"
      height="48"
    >
      <rect width="48" height="48" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_384_3647)">
      <path
        d="M16 12.8L10 6.8L12.8 4L18.8 10L16 12.8ZM32 12.8L29.2 10L35.2 4L38 6.8L32 12.8ZM22 10V0H26V10H22ZM8 48C7.43333 48 6.95833 47.8083 6.575 47.425C6.19167 47.0417 6 46.5667 6 46V30L10.2 18C10.4 17.4 10.7583 16.9167 11.275 16.55C11.7917 16.1833 12.3667 16 13 16H35C35.6333 16 36.2083 16.1833 36.725 16.55C37.2417 16.9167 37.6 17.4 37.8 18L42 30V46C42 46.5667 41.8083 47.0417 41.425 47.425C41.0417 47.8083 40.5667 48 40 48H38C37.4333 48 36.9583 47.8083 36.575 47.425C36.1917 47.0417 36 46.5667 36 46V44H12V46C12 46.5667 11.8083 47.0417 11.425 47.425C11.0417 47.8083 10.5667 48 10 48H8ZM11.6 26H36.4L34.3 20H13.7L11.6 26ZM15 38C15.8333 38 16.5417 37.7083 17.125 37.125C17.7083 36.5417 18 35.8333 18 35C18 34.1667 17.7083 33.4583 17.125 32.875C16.5417 32.2917 15.8333 32 15 32C14.1667 32 13.4583 32.2917 12.875 32.875C12.2917 33.4583 12 34.1667 12 35C12 35.8333 12.2917 36.5417 12.875 37.125C13.4583 37.7083 14.1667 38 15 38ZM33 38C33.8333 38 34.5417 37.7083 35.125 37.125C35.7083 36.5417 36 35.8333 36 35C36 34.1667 35.7083 33.4583 35.125 32.875C34.5417 32.2917 33.8333 32 33 32C32.1667 32 31.4583 32.2917 30.875 32.875C30.2917 33.4583 30 34.1667 30 35C30 35.8333 30.2917 36.5417 30.875 37.125C31.4583 37.7083 32.1667 38 33 38ZM10 40H38V30H10V40Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default Icon(IconDelivery)
